import React from "react";
import Skeleton from "../../skeleton";

const Dekstop = () => (

	<>
		<div className="card-skeleton-tab-all">
			<div className="card-skeleton-tab-all__section-keyword">
				<Skeleton
					width="200px"
					height="20px"
				/>
			</div>
			<div className="card-skeleton-tab-all__section-tabs">

				{Array.from({ length: 7 }, (value, id) => (
					<Skeleton
						width="100px"
						height="40px"
						key={id}
					/>

				))}
			</div>
			<div className="card-skeleton-tab-all__section-product">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-all__product">
					{Array.from({ length: 6 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-all__product-data">
							<Skeleton
								width="80px"
								height="80px"
							/>
							<div className="card-skeleton-tab-all__product-description">
								<Skeleton
									width="100px"
									height="16px"
								/>
								<Skeleton
									width="160px"
									height="16px"
								/>
							</div>
						</div>
					))}
				</div>
			</div>

			<div className="card-skeleton-tab-all__section-brand">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-all__brand">
					{Array.from({ length: 6 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-all__brand-data">
							<Skeleton
								width="150px"
								height="72px"
							/>
						</div>
					))}
				</div>
			</div>

			<div className="card-skeleton-tab-all__section-article">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-all__article">
					{Array.from({ length: 3 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-all__article-data">
							<Skeleton
								width="100px"
								height="66.67px"
							/>
							<div className="card-skeleton-tab-all__article-description">
								<Skeleton
									width="120px"
									height="16px"
								/>
								<Skeleton
									width="500px"
									height="16px"
								/>
							</div>
						</div>
					))}
				</div>
			</div>

			<div className="card-skeleton-tab-all__section-user">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-all__user">
					{Array.from({ length: 4 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-all__user-data">
							<Skeleton
								width="60px"
								height="60px"
								borderRadius="50%"
							/>
							<Skeleton
								width="80px"
								height="16px"
							/>

						</div>
					))}
				</div>
			</div>

			<div className="card-skeleton-tab-all__section-group">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-all__group">
					{Array.from({ length: 4 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-all__group-data">
							<Skeleton
								width="60px"
								height="60px"
								borderRadius="50%"
							/>
							<Skeleton
								width="80px"
								height="16px"
							/>

						</div>
					))}
				</div>
			</div>

			<div className="card-skeleton-tab-all__section-topic">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-all__topic">
					{Array.from({ length: 2 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-all__topic-data">
							<div className="card-skeleton-tab-all__topic-profile">
								<Skeleton
									width="24px"
									height="24px"
									borderRadius="50%"
								/>
								<Skeleton
									width="124px"
									height="16px"
								/>

							</div>
							<div className="card-skeleton-tab-all__topic-description">
								{Array.from({ length: 2 }, (data, idx) => (
									<Skeleton
										width="952"
										height="16px"
										key={idx}
									/>
								))}
								<Skeleton
									width="461.71px"
									height="16px"
								/>

							</div>

						</div>
					))}
				</div>
			</div>

		</div>
		<style jsx>
			{`
				.card-skeleton-tab-all{
					max-width: 1000px;
					margin-top: 38px;
				}
				.card-skeleton-tab-all__section-keyword{
					margin-top: 32px;
				}
				.card-skeleton-tab-all__section-tabs{
					display: grid;
    				grid-template-columns: repeat(7, 1fr);
					margin-top:32px;
					margin-bottom: 39px;
				}
				.card-skeleton-tab-all__product{
					display: grid;
    				grid-template-columns: repeat(3, 1fr);
				}
				.card-skeleton-tab-all__product-data{
					display: flex;
					gap: 8px;
					align-items: center;
					margin-top: 39px;
				}
				.card-skeleton-tab-all__section-brand{
					margin-top:55px;
				}
				.card-skeleton-tab-all__brand {
					display: flex;
					justify-content: space-between;
					margin-top: 18px;
				}
				.card-skeleton-tab-all__section-article {
					margin-top: 38px;
				}
				.card-skeleton-tab-all__article-data {
					display: flex;
					align-items: center;
					gap: 8px;
					margin-bottom: 20px;
				}
				.card-skeleton-tab-all__article {
					margin-top: 18px;
				}
				.card-skeleton-tab-all__user-data {
					display: flex;
					align-items: center;
					column-gap: 12px;
				}
				.card-skeleton-tab-all__user {
					display: grid;
					grid-template-columns: repeat(4, 1fr);
					row-gap: 30px;
					margin-top: 18px;
				}
				.card-skeleton-tab-all__section-user {
					margin-top: 38px;
				}
				.card-skeleton-tab-all__group-data {
					display: flex;
					align-items: center;
					column-gap: 12px;
				}
				.card-skeleton-tab-all__group {
					display: grid;
					grid-template-columns: repeat(4, 1fr);
					row-gap: 30px;
					margin-top: 18px;
				}
				.card-skeleton-tab-all__section-group {
					margin-top: 38px;
				}
				.card-skeleton-tab-all__topic-profile{
					display: flex;
					align-items: center;
					gap: 8px;
					margin-bottom: 20px;
				}
				.card-skeleton-tab-all__topic-data{
					border: 1px solid #DFE3E8;
					border-radius: 8px;
					padding: 24px;
					margin-bottom: 20px;
				}
				.card-skeleton-tab-all__topic{
					margin-top: 18px;
				}
				.card-skeleton-tab-all__section-topic{
					margin-top: 38px;
				}
		`}
		</style>
	</>

);

export default Dekstop;
